<template>
  <div>
    <div id="g-recaptcha"></div>
    <p class="recap"><small>This site is protected by reCAPTCHA and the Google
      <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a> and
      <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a> apply.</small></p>
  </div>
</template>

<script>

export default {
  name: "Recaptcha",
  data() {
    return {
      siteKey: process.env.VUE_APP_RECAPTCHA_PUBLIC_KEY,
      widgetId: 0
    }
  },
  methods: {
    execute() {
      window.grecaptcha.execute(this.widgetId);
    },
    reset() {
      window.grecaptcha.reset(this.widgetId);
    },
    render() {
        this.widgetId = window.grecaptcha.render('g-recaptcha', {
          sitekey: this.siteKey,
          size: 'invisible',
          badge: 'inline',
          callback: (response) => {
            this.$emit('verify', response);
            this.reset();
          }
      });
    },
    initReCaptcha() {
      setTimeout(() => {
        if (typeof window.grecaptcha === 'undefined' || typeof window.grecaptcha.render === 'undefined') {
          this.initReCaptcha();
        } else {
          this.render();
        }
      }, 200);
    }
  },
  mounted() {
    if (typeof window.grecaptcha === "undefined") {
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js')
      recaptchaScript.async = true
      recaptchaScript.defer = true
      recaptchaScript.onload = this.initReCaptcha;
      document.head.appendChild(recaptchaScript);
    }
  },
}

</script>

<style lang="scss">
  .grecaptcha-badge {
    display: none !important;
  }

  .recap {
    margin-top: 15px;
    font-size: .95rem;
    color: #666666;
    line-height: .85;
  }
</style>